<template>
<div id="app" v-loading.fullscreen.lock="!$teras.app.ready" :class="'device-'+$teras.app.device">

   <div class="app-main row">
      <div id="main" class="col s12" >
         <router-view name="main"></router-view>
      </div><!-- end main -->
   </div><!-- end container -->
   
</div> <!-- end app -->
</template>

<script>
import aes from './teras/aes'
export default {
   name: 'app',
   components: {
   },
  created () {
    console.log("Arrivo al APP.vue")
    console.log(aes.encode(2))
  },
}
</script>
